import { Link } from 'react-router-dom';

const ContactCTA = () => {
  return (
    <section className="py-24 bg-silver-light/30">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <div className="bg-white rounded-3xl p-12 shadow-card">
          <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-question-answer-line text-primary text-4xl"></i>
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold text-graphite mb-4">
            ¿No encuentras la respuesta que buscas?
          </h2>
          
          <p className="text-lg text-gray-medium mb-8 max-w-2xl mx-auto">
            Nuestro equipo está disponible para resolver cualquier duda sobre nuestros servicios de vaciado y limpieza en Castelldefels
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:+34602365996"
              className="w-full sm:w-auto px-6 sm:px-8 py-4 bg-primary text-white rounded-lg font-semibold text-base sm:text-lg hover:bg-primary-dark hover:shadow-glow transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Llamar
            </a>
            <Link
              to="/contacto"
              className="w-full sm:w-auto px-6 sm:px-8 py-4 border-2 border-primary text-primary rounded-lg font-semibold text-base sm:text-lg hover:bg-primary hover:text-white transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-line mr-2"></i>
              Escribir
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;
